/** Official high-resolution Latin Paye Tech lockup in every UI language. */
const source = '/images/brand/paye-tech-lockup.png'
const sourceWidth = 2140
const sourceHeight = 735

export function FooterBrandLogo() {
  return (
    <span className="paye-footer__brand-art paye-footer__brand-art--en" role="img" aria-label="Paye Tech" dir="ltr">
      <svg className="paye-footer__brand-symbol" viewBox="110 180 415 356" focusable="false" aria-hidden="true">
        <image href={source} x="0" y="0" width={sourceWidth} height={sourceHeight} />
      </svg>
      <svg className="paye-footer__brand-wordmark" viewBox="574 179 595 388" focusable="false" aria-hidden="true">
        <image href={source} x="0" y="0" width={sourceWidth} height={sourceHeight} />
      </svg>
    </span>
  )
}
